import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import {
  Timeline,
  TimelineConnector,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import { get, isNil } from 'lodash';
import moment from 'moment';
import { renderTimelineRegulationDecision } from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/utils';

import { TIMELINE_REGULATION_STATUS } from 'containers/data-structure';
import { COLORS } from 'constants/design';
import { translate } from 'containers/services/translate';
import messages from 'containers/RecapManagerPage/messages';

export interface RegulationHistoryTimelineProps {
  intl: IntlShape;
  history: any;
  regulationRejectionInfo: any;
}

const statusColors = {
  [TIMELINE_REGULATION_STATUS.PENDING]: COLORS.MUSTARD,
  [TIMELINE_REGULATION_STATUS.VALIDATED]: COLORS.GREEN,
  [TIMELINE_REGULATION_STATUS.REJECTED]: COLORS.RED,
};

const RegulationHistoryTimeline: React.FC<RegulationHistoryTimelineProps> = (
  props,
): JSX.Element => {
  return (
    <Timeline style={{ padding: '0px 0px' }}>
      {get(props, 'history', []).map((el: any) => (
        <TimelineItem style={{ width: '100%' }}>
          <TimelineSeparator>
            <TimelineDot
              style={{
                backgroundColor: statusColors[el.status],
              }}
            />
            <TimelineConnector />
          </TimelineSeparator>
          <Grid container direction="column" style={{ padding: '6px' }}>
            <span
              style={{
                color: 'rgba(0, 0, 0, 1)',
                fontSize: '14px',
                fontWeight: 400,
                width: '100%',
                display: 'block',
              }}
            >
              {el.status !== TIMELINE_REGULATION_STATUS.PENDING && el.decidedBy}{' '}
              {renderTimelineRegulationDecision(el.status, el.rejectionType)}{' '}
              {el.managerInbox.title}
              <br />
              {el.comment && el.status === TIMELINE_REGULATION_STATUS.VALIDATED
                ? `${translate(messages.comment, props)} : ${el.comment}`
                : el.status === TIMELINE_REGULATION_STATUS.REJECTED
                ? `${translate(messages.reason, props)} : ${get(
                    props.regulationRejectionInfo,
                    'title',
                    null,
                  )} ${
                    !isNil(get(el, 'comment', null))
                      ? ' - ' + get(el, 'comment', null)
                      : ''
                  }`
                : ' '}
            </span>
            <span
              style={{
                color: 'rgba(114, 122, 131, 1)',
                fontSize: '12px',
                fontWeight: 400,
              }}
            >
              {el.decidedAt && moment(el.decidedAt).format('DD/MM/YYYY HH:mm')}
              {el.isLast && ` (${translate(messages.lastValidation, props)})`}
            </span>
          </Grid>
        </TimelineItem>
      ))}
    </Timeline>
  );
};
export default injectIntl(RegulationHistoryTimeline);
